import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { TextArea } from 'components/TextArea';

const Container = styled.div`
  position: fixed;
  bottom: 0.8rem;
  right: 3rem;
  z-index: 99999;

  height: 49rem;
  width: 39rem;

  background-color: ${pickColor('white')};
  border: 0.1rem solid ${pickColor('black')};
  border-radius: ${({ theme }) => theme.borderRadius.big};
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
`;

const Messages = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  margin: 1.4rem;

  overflow-y: auto;
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  justify-content: center;
  align-items: center;

  height: 3.9rem;
  padding: 0 0.7rem;

  background-color: ${pickColor('black')};
`;

const Name = styled(Headline)`
  grid-column-start: 2;
`;

const CloseButton = styled(Button)`
  margin-left: auto;
`;

const SendButton = styled(Button)`
  margin-left: 1rem;

  align-self: flex-end;
`;

const TextContent = styled.div`
  display: flex;

  min-height: 6.9rem;
  width: 100%;
  padding: 1.9rem 1.6rem 1.4rem 1.6rem;

  background-color: ${pickColor('message')};
`;

const ButtonContainer = styled.div`
  overflow: hidden;
`;

const Area = styled(TextArea)`
  flex: 1;

  transition: 250ms;
`;

const Date = styled(Headline)`
  margin-bottom: 1.2rem;
`;

export {
  Container,
  Inner,
  Messages,
  Header,
  CloseButton,
  Name,
  TextContent,
  Area,
  SendButton,
  ButtonContainer,
  Date,
};
